import styled from 'styled-components';

const StyledErrorMessage = styled.div`
  color: red;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export default StyledErrorMessage;
